// export default TrekInfo;
import { useState } from "react";
import TrekCard from "../CommonUI/TrekCard";

const TrekInfo = ({ treks }) => {
  const [showAll, setShowAll] = useState(false);

  const displayedTreks = showAll ? treks : treks.slice(0, 4);

  return (
    <section className="bg-gradient-to-b from-amber-50 to-white px-4 py-10 sm:px-6 sm:py-14">
      <div className="mx-auto max-w-7xl">
        <div className="mb-7 text-center sm:mb-9">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-blue-800">
            Explore the Western Ghats
          </p>
          <h1 className="mt-2 text-3xl font-bold text-stone-900 sm:text-4xl">
            Sahyadri Treks
          </h1>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-6 text-stone-600 sm:text-base">
            Discover forts, forest paths, and waterfalls across the Sahyadri
            range.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:gap-5 lg:grid-cols-4">
          {displayedTreks.map((trek) => (
            <TrekCard key={trek.id} trek={trek} />
          ))}
        </div>

        {treks.length > 4 && (
          <div className="mt-6 flex justify-center">
            <button
              onClick={() => setShowAll(!showAll)}
              className="rounded-full bg-blue-800 px-6 py-2.5 text-sm font-semibold text-white transition hover:bg-blue-900"
            >
              {showAll ? "View Less" : "View More"}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default TrekInfo;
